import {
  DownloadOutlined,
  EyeOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, DatePicker, Input, Row, Tooltip } from "antd";
import { Select } from "antd";
import { Form } from "antd";
import React, { FC, useEffect, useState } from "react";
import { IFetchAllDetails } from "../../../../../interfaces/IPatient";
import dayjs from "dayjs";
import { errorMessage } from "../../../../../utils/notificationUtils";
import { handleDownloadExcel } from "../../../../../apis/patientService";
import ReferralChecklistModal from "../../../../modals/ReferralChecklistModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import { isMidOfficeRole } from "../../../../../utils/roleUtils";
import { Spin } from "antd";
import RightSidePreviewWindow from "../../../../modals/PreviewModalForDrawer";

type ProcedureNewProps = {
  form: any;
  patientDetails: IFetchAllDetails | null;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  portalData: any;
  isApproved: boolean;
  handleGetProcedureFromBill: any;
  isFetchingBillAuditProcedure: any;
  isFetchingBillDetails: any;
  allDocumentList?: any;
};

const ProcedureNew: FC<ProcedureNewProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const [referralChecklistModal, setReferralChecklistModal] =
    useState<boolean>(false);

  const items = Form.useWatch("items", props?.form);

  const { auth, preAuthClaim } = useSelector((state: RootState) => state);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (items?.length > 0) {
      const total = items?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.unspecifiedProcedureAmount
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);

        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      props?.form.setFieldsValue({ totalIntimatedAmount: total });
    } else {
      props?.form.setFieldsValue({ totalIntimatedAmount: "0" });
    }
  }, [items, props?.form]);

  useEffect(() => {
    if (!props?.form.getFieldValue("items") || items?.length === 0) {
      const items = [
        {
          treatmentStartDate: props.patientDetails?.visitInfoResponse?.doa
            ? dayjs(
                props.patientDetails?.visitInfoResponse?.doa,
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          numberOfDays: "1",
          accreditationStatus:
            // !props?.patientDetails?.casesResponse?.healthCareName
            //   ?.toLowerCase()
            //   ?.includes("saroj gupta")
            //   ? "NABL~NABL"
            //   : "NON NABL~NON NABL",
            props?.patientDetails?.casesResponse?.nablStatus
              ? "NABL~NABL"
              : props?.patientDetails?.casesResponse?.nabhStatus
                ? "NABH~NABH"
                : "NON NABH~NON NABH",
          treatingDoctor: "OTHERS~OTHERS",
          procedureReferral: "referral~REFERRAL",
        },
      ];

      props?.form.setFieldsValue({ items });
    }
  }, [
    items?.length,
    props?.form,
    props.patientDetails?.casesResponse?.healthCareName,
    props.patientDetails?.visitInfoResponse?.doa,
  ]);

  useEffect(() => {
    const fetchProcedureStratsData = async () => {
      const updatedItems = [...items];
      let hasChanges = false;

      for (let index = 0; index < updatedItems?.length; index++) {
        const procedure = updatedItems[index];
        if (
          procedure?.stratsId &&
          !props?.procedureStrats[procedure?.stratsId] &&
          procedure?.strats?.toLowerCase()?.includes("y")
        ) {
          try {
            const formData = {
              procedureId: items[index]?.stratsId,
              hospitalId: props?.patientDetails?.casesResponse?.healthCareId,
              isCghs:
                props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                "CGHS"
                  ? true
                  : false,
              schemeId: props?.patientDetails?.casesResponse?.schemeMetaDataId,
            };
            const result = await props?.handleGetProcedureStrats(formData);

            if (!procedure.stratsName) {
              props?.form.setFieldsValue({
                items: {
                  [index]: {
                    stratsName: result?.stratsName,
                  },
                },
              });
              updatedItems[index] = {
                ...procedure,
                stratsName: result?.stratsName,
              };
              hasChanges = true;
            }
          } catch (error) {}
        } else if (
          procedure?.stratsId &&
          props?.procedureStrats[procedure?.stratsId]
        ) {
          if (!procedure.stratsName) {
            props?.form.setFieldsValue({
              items: {
                [index]: {
                  stratsName: props?.procedureStrats[procedure?.stratsId],
                },
              },
            });
            updatedItems[index] = {
              ...procedure,
              stratsName:
                props?.procedureStrats[procedure?.stratsId]?.stratsName,
            };
            hasChanges = true;
          }
        }
      }

      if (hasChanges) {
        props?.form.setFieldValue({ items: updatedItems });
      }
    };

    if (items?.length > 0) {
      fetchProcedureStratsData();
    }
  }, [items]);

  const procedureCodingOptions = ["Package - Nabh/Non-Nabh", "Package - Nabl"];
  const [selectedProcedureCodingOption, setSelectedProcedureCodingOption] =
    useState<any>();

  const handleDownloadExcel = () => {
    const link = document.createElement("a");
    link.href =
      selectedProcedureCodingOption === "Package - Nabh/Non-Nabh"
        ? props?.patientDetails?.casesResponse?.cghsPackageLink
        : props?.patientDetails?.casesResponse?.cghsNablLink;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };

  const handlePreviewDocument = () => {
    const hosiptalBill = props?.allDocumentList?.["Bill Audit"]?.find(
      (doc: any) => doc?.id === "HOSPITAL_BILL",
    );
    const link = hosiptalBill?.data;
    setPreviewDocumentUrl(link);
    setPreviewDocument(true);
  };

  return (
    <>
      {preAuthClaim?.isFetchingProcedure ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                paddingRight: "50px",
              }}
            >
              <div
                style={{
                  textDecoration: "underline",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                Treatment Plan/Procedure Coding
              </div>

              {props?.patientDetails?.visitInfoResponse?.visitType?.toUpperCase() === "OP" && 
              (isMidOfficeRole(auth?.role?.role) || auth?.role?.role == "BO_STAFF") && (
                <div style={{ marginLeft: "auto" }}>
                  <Tooltip title="Bill Preview">
                    <EyeOutlined
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handlePreviewDocument()}
                    />
                  </Tooltip>
                </div>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              {/* {props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted || props?.isApproved || auth?.role?.role === "FO_STAFF" ? (
            <></>
          ) : (
            props?.patientDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" && (
              <div>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#D2691E",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  onClick={props?.handleGetProcedureFromBill}
                  loading={props?.isFetchingBillAuditProcedure}
                >
                  Import Procedure From Bill
                </Button>
              </div>
            )
          )} */}

              {/* {props?.patientDetails?.referralInfoResponse?.cghsReferralResponse
            ?.id ? (
            <div>
              <Button
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 76, 143)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                // onClick={() => handleSubmit(true)}
                onClick={() => setReferralChecklistModal(true)}
              >
                Referral Checklist
              </Button>
            </div>
          ) : <></>} */}

              {props?.patientDetails?.casesResponse?.cghsPackageLink ||
              props?.patientDetails?.casesResponse?.cghsNablLink ? (
                <div
                  className="dropdown"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    paddingLeft: 0,
                  }}
                >
                  <Col span={24}>
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      defaultValue={`Select a Document`}
                      options={procedureCodingOptions?.map((option: any) => ({
                        value: option,
                        label: option,
                      }))}
                      onChange={(value) =>
                        setSelectedProcedureCodingOption(value)
                      }
                    />
                  </Col>
                  {selectedProcedureCodingOption ? (
                    <DownloadOutlined onClick={handleDownloadExcel} />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {props?.isFetchingBillDetails ? (
            <div
              style={{
                margin: "auto",
                width: "100%,",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin />
            </div>
          ) : (
            <Form
              form={props?.form}
              // onFinish={handleSubmit}
              labelAlign="left"
              labelWrap
              labelCol={{
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 8 },
                lg: { span: 6 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 16 },
                lg: { span: 18 },
              }}
              style={{ width: "100%" }}
            >
              <Form.List name="items">
                {(fields, { add, remove }) => (
                  <div
                    style={{
                      // border:
                      //   Array.isArray(fields) && fields?.length > 0
                      //     ? "1px solid #D9D9D9"
                      //     : "none",
                      borderRadius: "16px",
                      padding: "10px 0px",
                      marginBottom: "0.8rem",
                      width: "100%",
                      maxHeight: "50vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                      paddingRight: "6px",
                    }}
                  >
                    {Array.isArray(fields) &&
                      fields?.map((field: any, index) => {
                        return (
                          <div
                            style={{
                              // border: "1px solid #C4C4C4",
                              // padding: "10px 20px 60px 20px",
                              borderRadius: "16px",
                              border: "0.4px solid #A6A6A6",
                              padding: "20px 10px",
                              marginBottom: "0.8rem",
                              paddingBottom: "50px",
                            }}
                          >
                            <Col
                              span={1}
                              // style={{ marginTop: "30px" }}
                            >
                              <span
                                style={{
                                  background: "#00549E",
                                  color: "white",
                                  borderRadius: "50%",
                                  padding: "0 4px",
                                  fontSize: "12px",
                                  height: "20px",
                                  width: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {index + 1}
                              </span>
                            </Col>
                            <Row
                              key={field.key}
                              gutter={[24, 48]}
                              align="top"
                              style={
                                {
                                  // border: "1px solid #C4C4C4",
                                  // padding: "10px 20px 60px 20px",
                                  // borderRadius: "16px",
                                  // marginBottom: "0.8rem",
                                  // // border: "0.4px solid #A6A6A6",
                                  // padding: "20px 0 30px 0",
                                }
                              }
                            >
                              {/* <Col span={3}>
                          <Form.Item
                            {...field}
                            label="PROC. REF."
                            name={[field.name, "procedureReferral"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Procedure Referral`}
                              options={props?.formattedProcedureReferral}
                              disabled={
                                props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
                              }
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3}>
                          <Form.Item
                            {...field}
                            label="Ref. Proc. Type"
                            name={[field.name, "referralType"]}
                            // rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px", color: "black" }}
                              placeholder="Enter Referral Type"
                              disabled={
                                props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted
                              }
                              // disabled={true}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={6}>
                          <Form.Item
                            {...field}
                            label="Referral Procedure Name"
                            name={[field.name, "referralServiceName"]}
                            // rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px", color: "black" }}
                              placeholder="Enter Referral Procedure Name"
                              disabled={
                                props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted
                              }
                              // disabled={true}
                            />
                          </Form.Item>
                        </Col> */}

                              <Col span={6}>
                                <Form.Item
                                  {...field}
                                  label="Procedure"
                                  name={[field.name, "procedureCode"]}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Select
                                    showSearch
                                    disabled={
                                      props?.portalData?.casePreAuthCghs
                                        ?.casePreAuthResponse?.submitted
                                    }
                                    defaultValue={`Select a Procedure`}
                                    options={props?.formattedProceduresOptions}
                                    onChange={async (value, option: any) => {
                                      const externalProcedureCode =
                                        JSON.parse(value).externalProcedureCode;
                                      const accreditationStatus =
                                        props?.form.getFieldValue([
                                          "items",
                                          index,
                                          "accreditationStatus",
                                        ]);

                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            externalProcedureCode,
                                          },
                                        },
                                      });

                                      const formData = {
                                        procedureId: externalProcedureCode,
                                        ward:
                                          props?.patientDetails?.patientResponse
                                            ?.cardCategory || "Semi Private",
                                        isNabl:
                                          props?.patientDetails?.casesResponse
                                            ?.nabhStatus ||
                                          props?.patientDetails?.casesResponse
                                            ?.nablStatus,
                                        // accreditationStatus?.split("~")?.[1] ===
                                        //   "NABL" ||
                                        // accreditationStatus?.split("~")?.[1] ===
                                        //   "NABH",
                                      };

                                      let result;
                                      let finalIsNablUsed = formData.isNabl;

                                      // try {
                                      //   result =
                                      //     await props?.handleGetProcedureAmount(
                                      //       formData,
                                      //     );

                                      //   const hasValidAmount =
                                      //     result?.nablPackageAmount ||
                                      //     result?.nabhPackageAmount;

                                      //   // if (!hasValidAmount) {
                                      //   //   const fallbackFormData = {
                                      //   //     ...formData,
                                      //   //     isNabl: false,
                                      //   //   };
                                      //   //   result =
                                      //   //     await props?.handleGetProcedureAmount(
                                      //   //       fallbackFormData
                                      //   //     );
                                      //   //   finalIsNablUsed = false;
                                      //   // }
                                      // } catch (err) {
                                      //   // try {
                                      //   //   const fallbackFormData = {
                                      //   //     ...formData,
                                      //   //     isNabl: false,
                                      //   //   };
                                      //   //   result =
                                      //   //     await props?.handleGetProcedureAmount(
                                      //   //       fallbackFormData
                                      //   //     );
                                      //   //   finalIsNablUsed = false;
                                      //   // } catch (fallbackErr: any) {
                                      //   //   // errorMessage(fallbackErr?.response?.data);
                                      //   // }
                                      // }

                                      // const amount = !finalIsNablUsed
                                      //   ? result?.nonNabhPackageAmount
                                      //   : result?.nabhPackageAmount;

                                      const amount = option?.extra?.amount;

                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            procedureAmount: amount,
                                            isAmountAutoFilled: amount
                                              ? true
                                              : false,
                                          },
                                        },
                                      });

                                      if (
                                        value &&
                                        JSON.parse(value)
                                          ?.strats?.toLowerCase()
                                          ?.includes("y")
                                      ) {
                                        const stratsFormData = {
                                          procedureId: JSON.parse(value)?.id,
                                        };

                                        const res =
                                          await props?.handleGetProcedureStrats(
                                            stratsFormData,
                                          );
                                        props?.form.setFieldsValue({
                                          items: {
                                            [index]: {
                                              stratsName: res?.stratsName,
                                            },
                                          },
                                        });
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item
                                  {...field}
                                  label="ICHI Code"
                                  name={[field.name, "externalProcedureCode"]}
                                  // rules={[{ required: true, message: "Required" }]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    style={{
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    placeholder="Enter ICHI Code"
                                    disabled={true}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item
                                  {...field}
                                  label="QUANTITY/NO OF DAYS"
                                  name={[field.name, "numberOfDays"]}
                                  rules={[
                                    { required: true, message: "Required" },
                                    {
                                      pattern: /^\d+$/,
                                      message:
                                        "Only Numeric values are allowed!",
                                    },
                                    {
                                      validator: (_, value) =>
                                        value && parseInt(value, 10) < 1
                                          ? Promise.reject(
                                              "Please Enter Valid QUANTITY/NO OF DAYS!",
                                            )
                                          : Promise.resolve(),
                                    },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    style={{
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    placeholder="Enter QUANTITY/NO OF DAYS"
                                    disabled={
                                      props?.portalData?.casePreAuthCghs
                                        ?.casePreAuthResponse?.submitted
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              {/* <Col span={4}>
                          <Form.Item
                            {...field}
                            label="TREATING DOCTOR"
                            name={[field.name, "treatingDoctor"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Treating Doctor`}
                              options={props?.formattedTreatingDoctorsOptions}
                              disabled={
                                props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted
                              }
                            />
                          </Form.Item>
                        </Col> */}

                              {/* {props?.form.getFieldValue([
                        "items",
                        index,
                        "procedureCode", 
                      ]) &&
                      JSON.parse(
                        props?.form.getFieldValue([
                          "items",
                          index,
                          "procedureCode",
                        ])
                      )?.nablStatus ? ( */}

                              {/* <Col span={4}>
                          <Form.Item
                            {...field}
                            label="ACCREDITATION STATUS"
                            name={[field.name, "accreditationStatus"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Accreditation Status`}
                              options={props?.formattedAccreditationOptions}
                              // disabled={
                              //   props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
                              // }
                              disabled={true}
                              onChange={async (value) => {
                                const externalProcedureCode =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "externalProcedureCode",
                                  ]);
                                const formData = {
                                  procedureId: externalProcedureCode,
                                  ward:
                                    props?.patientDetails?.patientResponse
                                      ?.cardCategory || "Semi Private",
                                  isNabl: (props?.patientDetails?.casesResponse?.nabhStatus || props?.patientDetails?.casesResponse?.nablStatus)
                                    // value?.split("~")?.[1] === "NABL" ||
                                    // value?.split("~")?.[1] === "NABH"
                                    //   ? true
                                    //   : false,
                                };
                                // const getAmount =
                                //   await props?.handleGetProcedureAmount(
                                //     formData
                                //   );
                                // const amount = !formData?.isNabl
                                //   ? getAmount?.nonNabhPackageAmount
                                //   : getAmount?.nabhPackageAmount;

                                // props?.form.setFieldsValue({
                                //   items: {
                                //     [index]: {
                                //       procedureAmount: amount,
                                //     },
                                //   },
                                // });
                              }}
                            />
                          </Form.Item>
                        </Col> */}
                              {/* ) : (
                        <></>
                      )} */}

                              <Col span={5}>
                                <Form.Item
                                  {...field}
                                  label="TREATMENT START DATE"
                                  name={[field.name, "treatmentStartDate"]}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                  }}
                                >
                                  <DatePicker
                                    showTime
                                    format={dateFormat}
                                    style={{
                                      width: "100%",
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    allowClear={true}
                                    inputReadOnly={false}
                                    disabled={
                                      props?.portalData?.casePreAuthCghs
                                        ?.casePreAuthResponse?.submitted
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              {/* {!props?.form
                            .getFieldValue(["items", index, "procedureCode"])
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={4}>
                              <Form.Item
                                {...field}
                                label="AMOUNT"
                                name={[field.name, "procedureAmount"]}
                                rules={[
                                  { required: true, message: "Required" },
                                  {
                                    pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                    message:
                                      "Only numeric values with upto 2 dec. places!",
                                  },
                                  {
                                    validator: (_, value) =>
                                      value && parseInt(value, 10) < 1
                                        ? Promise.reject(
                                            "Please Enter Valid Amount!",
                                          )
                                        : Promise.resolve(),
                                  },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Amount"
                                  disabled={
                                    props?.portalData?.casePreAuthCghs
<<<<<<< HEAD
<<<<<<< HEAD
                                      ?.casePreAuthResponse?.submitted ||  props?.form.getFieldValue(["items", index, "isAmountAutoFilled"])
=======
=======
>>>>>>> 9378fcd1300d7f48bdb57fbd23edf671ecef130d
                                      ?.casePreAuthResponse?.submitted ||
                                    props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "isAmountAutoFilled",
                                    ])
<<<<<<< HEAD
>>>>>>> fb97d74c5 (Cghs procedure changes)
=======
>>>>>>> 9378fcd1300d7f48bdb57fbd23edf671ecef130d
                                  }
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )} */}

                              {(() => {
                                const procedureCodeStr =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]);
                                if (!procedureCodeStr) return null;

                                const procedureCodeObj =
                                  JSON.parse(procedureCodeStr);

                                // Show this input only if procedureName does NOT contain "unspecified"
                                const isNotUnspecified =
                                  !procedureCodeObj.specialityType
                                    ?.toLowerCase()
                                    ?.includes("s");

                                return isNotUnspecified ? (
                                  <Col span={4}>
                                    <Form.Item
                                      {...field}
                                      label="AMOUNT"
                                      name={[field.name, "procedureAmount"]}
                                      rules={[
                                        { required: true, message: "Required" },
                                        {
                                          pattern:
                                            /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                          message:
                                            "Only numeric values with upto 2 dec. places!",
                                        },
                                        {
                                          validator: (_, value) =>
                                            value && parseInt(value, 10) < 1
                                              ? Promise.reject(
                                                  "Please Enter Valid Amount!",
                                                )
                                              : Promise.resolve(),
                                        },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Amount"
                                        disabled={true}
                                        // disabled={
                                        //   props?.portalData?.casePreAuthCghs
                                        //     ?.casePreAuthResponse?.submitted ||
                                        //   props?.form.getFieldValue([
                                        //     "items",
                                        //     index,
                                        //     "isAmountAutoFilled",
                                        //   ])
                                        // }
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : null;
                              })()}

                              {/* {props?.form
                            .getFieldValue(["items", index, "procedureCode"])
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={4}>
                              <Form.Item
                                {...field}
                                label="PROCEDURE NAME"
                                name={[field.name, "unspecifiedProcedureName"]}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Procedure Name"
                                  disabled={
                                    props?.portalData?.casePreAuthCghs
                                      ?.casePreAuthResponse?.submitted
                                  }
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )} */}

                              {(() => {
                                const procedureCodeStr =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]);
                                if (!procedureCodeStr) return null;

                                const procedureCodeObj =
                                  JSON.parse(procedureCodeStr);

                                // Check if procedureName contains "unspecified" (case-insensitive)
                                const isUnspecified =
                                  procedureCodeObj.specialityType
                                    ?.toLowerCase()
                                    ?.includes("s");

                                return isUnspecified ? (
                                  <Col span={4}>
                                    <Form.Item
                                      {...field}
                                      label="PROCEDURE NAME"
                                      name={[
                                        field.name,
                                        "unspecifiedProcedureName",
                                      ]}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Procedure Name"
                                        disabled={
                                          props?.portalData?.casePreAuthCghs
                                            ?.casePreAuthResponse?.submitted
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : null;
                              })()}

                              <Col span={1}>
                                {fields.length > 1 &&
                                  !props?.portalData?.casePreAuthCghs
                                    ?.casePreAuthResponse?.submitted &&
                                  !props?.isApproved && (
                                    <Button
                                      type="text"
                                      style={{ color: "red", padding: "0" }}
                                      icon={<MinusCircleOutlined />}
                                      disabled={
                                        props?.portalData?.casePreAuthCghs
                                          ?.casePreAuthResponse?.submitted
                                      }
                                      onClick={async () => {
                                        const pid = items[index]?.pid;
                                        if (pid) {
                                          await props?.handleDeleteProcedure(
                                            pid,
                                          );
                                        }
                                        remove(field?.name);
                                      }}
                                    />
                                  )}
                              </Col>

                              {/* {props?.form
                            .getFieldValue(["items", index, "procedureCode"])
                            ?.toLowerCase()
                            ?.includes("unspecified") ? (
                            <Col span={4}>
                              <Form.Item
                                {...field}
                                label="PROCEDURE AMOUNT"
                                name={[
                                  field.name,
                                  "unspecifiedProcedureAmount",
                                ]}
                                rules={[
                                  { required: true, message: "Required" },
                                  {
                                    pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                    message:
                                      "Only numeric values with upto 2 dec. places!",
                                  },
                                  {
                                    validator: (_, value) =>
                                      value && parseInt(value, 10) < 1
                                        ? Promise.reject(
                                            "Please Enter Valid Amount!",
                                          )
                                        : Promise.resolve(),
                                  },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Procedure Amount"
                                  disabled={
                                    props?.portalData?.casePreAuthCghs
                                      ?.casePreAuthResponse?.submitted
                                  }
                                />
                              </Form.Item>
                            </Col>
                          ) : (
                            <></>
                          )} */}

                              {(() => {
                                const procedureCodeStr =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]);
                                if (!procedureCodeStr) return false;

                                const procedureCodeObj =
                                  JSON.parse(procedureCodeStr);

                                // Check if procedureName contains "unspecified" (case-insensitive)
                                const isUnspecified =
                                  procedureCodeObj.specialityType
                                    ?.toLowerCase()
                                    ?.includes("s");

                                return isUnspecified ? (
                                  <Col span={4}>
                                    <Form.Item
                                      {...field}
                                      label="PROCEDURE AMOUNT"
                                      name={[
                                        field.name,
                                        "unspecifiedProcedureAmount",
                                      ]}
                                      rules={[
                                        { required: true, message: "Required" },
                                        {
                                          pattern:
                                            /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                          message:
                                            "Only numeric values with upto 2 dec. places!",
                                        },
                                        {
                                          validator: (_, value) =>
                                            value && parseInt(value, 10) < 1
                                              ? Promise.reject(
                                                  "Please Enter Valid Amount!",
                                                )
                                              : Promise.resolve(),
                                        },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Procedure Amount"
                                        disabled={
                                          props?.portalData?.casePreAuthCghs
                                            ?.casePreAuthResponse?.submitted
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : null;
                              })()}

                              {props?.form.getFieldValue([
                                "items",
                                index,
                                "procedureCode",
                              ]) &&
                              JSON.parse(
                                props?.form.getFieldValue([
                                  "items",
                                  index,
                                  "procedureCode",
                                ]),
                              )
                                ?.strats?.toLowerCase()
                                ?.includes("y") ? (
                                <Col span={4}>
                                  <Form.Item
                                    {...field}
                                    label="STRATS NAME"
                                    name={[field.name, "stratsName"]}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Input
                                      style={{
                                        borderRadius: "5px",
                                        color: "black",
                                      }}
                                      placeholder="Enter Strats Name"
                                      disabled={true}
                                    />
                                  </Form.Item>
                                </Col>
                              ) : (
                                <></>
                              )}

                              {props?.form.getFieldValue([
                                "items",
                                index,
                                "procedureCode",
                              ]) &&
                              JSON.parse(
                                props?.form.getFieldValue([
                                  "items",
                                  index,
                                  "procedureCode",
                                ]),
                              )
                                ?.strats?.toLowerCase()
                                ?.includes("y") ? (
                                <Col span={4}>
                                  <Form.Item
                                    {...field}
                                    label="STRATS OPTIONS"
                                    name={[field.name, "stratOptionValue"]}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Select
                                      showSearch
                                      disabled={
                                        props?.portalData?.casePreAuthCghs
                                          ?.casePreAuthResponse?.submitted
                                      }
                                      defaultValue={`Select a Strats Value`}
                                      options={
                                        props?.form.getFieldValue([
                                          "items",
                                          index,
                                          "procedureCode",
                                        ]) &&
                                        (props?.procedureStrats[
                                          JSON.parse(
                                            props?.form.getFieldValue([
                                              "items",
                                              index,
                                              "procedureCode",
                                            ]),
                                          )?.id
                                        ]?.options?.map((option: any) => ({
                                          value: JSON.stringify(option),
                                          label: option?.stratOptionValue,
                                        })) ||
                                          [])
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              ) : (
                                <></>
                              )}

                              {/* <div style={{ width: "100%" }}>
                          <h4
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            Hospital Amount: ₹{" "}
                            {form.getFieldValue([
                              "items",
                              index,
                              "hospitalAmount",
                            ]) ?? 0}
                            /-
                          </h4>
                        </div> */}
                            </Row>
                          </div>
                        );
                      })}
                    <div style={{ textAlign: "right" }}>
                      <h4>
                        TOTAL PREAUTH AMOUNT: ₹{" "}
                        {props?.form.getFieldValue("totalIntimatedAmount") ??
                          "0"}
                        /-
                      </h4>
                      <div></div>
                    </div>
                    {!props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                      ?.submitted && !props?.isApproved ? (
                      <Button
                        type="dashed"
                        // onClick={() => add()}
                        onClick={() => {
                          add({
                            treatmentStartDate: props.patientDetails
                              ?.visitInfoResponse?.doa
                              ? dayjs(
                                  props.patientDetails?.visitInfoResponse?.doa,
                                  "DD-MM-YYYY HH:mm:ss",
                                )
                              : null,
                            numberOfDays: "1",
                            accreditationStatus:
                              // !props?.patientDetails?.casesResponse?.healthCareName
                              //   ?.toLowerCase()
                              //   ?.includes("saroj gupta")
                              //   ? "NABL~NABL"
                              //   : "NON NABL~NON NABL",
                              props?.patientDetails?.casesResponse?.nablStatus
                                ? "NABL~NABL"
                                : props?.patientDetails?.casesResponse
                                      ?.nabhStatus
                                  ? "NABH~NABH"
                                  : "NON NABH~NON NABH",
                            treatingDoctor: "OTHERS~OTHERS",
                            procedureReferral: "referral~REFERRAL",
                          });
                        }}
                        style={{
                          background: "rgb(0, 76, 143)",
                          color: "white",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          border: "1px solid #C4C4C4",
                        }}
                      >
                        Add Procedure
                      </Button>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </Form.List>
            </Form>
          )}

          <ReferralChecklistModal
            visible={referralChecklistModal}
            handleCancel={() => setReferralChecklistModal(false)}
            referralId={
              props?.patientDetails?.referralInfoResponse?.cghsReferralResponse
                ?.id
            }
            documentId={
              props?.patientDetails?.referralInfoResponse?.cghsReferralResponse
                ?.documentId
            }
          />

          <RightSidePreviewWindow
            key={previewDocumentUrl}
            documentUrl={previewDocumentUrl}
            handleCancel={() => setPreviewDocument(false)}
            open={previewDocument}
            setOpen={setOpen}
          />
        </>
      )}
    </>
  );
};

export default ProcedureNew;
